import { useState } from "react";

const LETTER_AR = `السادة المحترمين في الشركة السورية للاتصالات / تراسل،

تحية طيبة وبعد،

نحن شركة TWIN TC LLC، نستضيف على عنوان الإنترنت الثابت المخصص لنا:

    IP: 78.155.66.250

خادم قياس سرعة رسمياً معتمداً لدى منصة Ookla Speedtest العالمية (Speedtest.net) — معرّف الخادم: 75960، النطاق: ookla.twin-tc.net — وذلك لخدمة المستخدمين في سوريا وتحسين جودة قياس الاتصال محلياً.

تشترط منصة Ookla لتشغيل الخادم فتح المنفذين التاليين للاتصالات الواردة:
    • المنفذ 8080 (TCP + UDP) — يعمل حالياً بشكل سليم
    • المنفذ 5060 (TCP + UDP) — محجوب حالياً على مستوى الشبكة

وقد أجرينا فحوصات تقنية موثقة (tcpdump على الخادم + فحص من 6 دول مختلفة عبر أدوات مستقلة) أثبتت أن الحزم الموجهة إلى المنفذ 5060 لا تصل إلى خادمنا إطلاقاً من خارج الشبكة، بينما تصل حزم المنفذ 8080 بشكل طبيعي — مما يؤكد أن الحجب يتم على مستوى شبكة المزوّد.

نلفت عنايتكم إلى أن استخدامنا للمنفذ 5060 لا علاقة له بخدمات الاتصال الصوتي (VoIP/SIP) إطلاقاً؛ فهو مخصص حصراً لبروتوكول قياس السرعة الخاص بمنصة Ookla (OoklaServer daemon).

لذا نرجو من حضرتكم التكرم بـ:
    استثناء العنوان 78.155.66.250 من حجب المنفذ 5060 (TCP + UDP) للاتصالات الواردة.

علماً أن هذا الاستثناء ضروري لإتمام اعتماد الخادم رسمياً لدى Ookla، وسيعود بالفائدة على مستخدمي الإنترنت في سوريا عبر توفير نقطة قياس سرعة محلية دقيقة.

للتواصل التقني: ai@twin-tc.net

مع جزيل الشكر والتقدير،
TWIN TC LLC
https://twin-tc.net`;

const LETTER_EN = `To: Syrian Telecom / Tarassul — Network Operations

Subject: Request to unblock inbound port 5060 (TCP+UDP) for IP 78.155.66.250

Dear Sir/Madam,

TWIN TC LLC operates an official Ookla Speedtest server (Server ID: 75960, hostname: ookla.twin-tc.net) on our static IP address 78.155.66.250, serving Internet users in Syria.

Ookla requires the following inbound ports to be open:
  - Port 8080 TCP+UDP  (currently working correctly)
  - Port 5060 TCP+UDP  (currently blocked at the network level)

Our documented diagnostics (tcpdump on the server + independent probes from 6 countries) prove that packets to port 5060 never reach our server from outside the network, while port 8080 traffic arrives normally — confirming upstream filtering.

Please note this port is NOT used for VoIP/SIP; it is used exclusively by the OoklaServer speedtest protocol.

We kindly request an exception: unblock inbound TCP+UDP port 5060 for IP 78.155.66.250 only.

Technical contact: ai@twin-tc.net

Best regards,
TWIN TC LLC — https://twin-tc.net`;

const LETTER2_AR = `السادة المحترمين في الشركة السورية للاتصالات / تراسل،

الموضوع: متابعة طلب فتح المنفذ 5060 — الحجب ما زال قائماً على البوابة الدولية

تحية طيبة وبعد،

إشارة إلى طلبنا السابق بخصوص فتح المنفذ 5060 للعنوان 78.155.66.250، وإفادتكم الكريمة بأنه قد تم فتح المنفذ، نشكر لكم استجابتكم، ونود إحاطتكم بنتائج الفحوصات الفنية التي أجريناها بعد الفتح:

نتائج الفحص الموثقة:
    • من داخل الشبكة المحلية / الوطنية: المنفذ 5060 يعمل بشكل سليم ✓ (تم تأكيد وصول الحزم واستجابة الخادم عبر tcpdump)
    • من خارج القطر (فحص مستقل من 7 دول: البرازيل، إسبانيا، فنلندا، إيران، الولايات المتحدة وغيرها): المنفذ 5060 ما زال محجوباً بالكامل ✗ (انتهاء مهلة الاتصال — الحزم لا تصل إلى خادمنا إطلاقاً)
    • للمقارنة: المنفذ 8080 على نفس العنوان يعمل من جميع الدول المذكورة بشكل طبيعي ✓

الاستنتاج الفني:
يتضح من النتائج أعلاه أن الفتح الذي تم يقتصر على الشبكة المحلية/الوطنية، بينما ما زال الحجب قائماً على مستوى البوابة الدولية (International Gateway) للحركة الواردة من خارج القطر باتجاه المنفذ 5060.

المطلوب تحديداً:
    فتح المنفذ 5060 (TCP + UDP) للحركة الواردة من المسارات الدولية على البوابة الدولية، باتجاه العنوان 78.155.66.250 حصراً.

نذكّر بأن هذا المنفذ مخصص حصراً لبروتوكول قياس السرعة الخاص بمنصة Ookla Speedtest (خادم معتمد — معرّف: 75960)، ولا علاقة له بخدمات الاتصال الصوتي VoIP/SIP، وأن اعتماد الخادم النهائي لدى Ookla متوقف على وصول الحركة الدولية لهذا المنفذ.

للتواصل التقني: ai@twin-tc.net

مع جزيل الشكر والتقدير,
TWIN TC LLC
https://twin-tc.net`;

const LETTER2_EN = `To: Syrian Telecom / Tarassul — Network Operations / International Gateway Team

Subject: Follow-up — Port 5060 still blocked at the INTERNATIONAL GATEWAY for 78.155.66.250

Dear Sir/Madam,

Further to our previous request and your kind confirmation that port 5060 has been opened, we would like to share our post-change verification results:

Documented test results:
  - From inside the local/national network: port 5060 works correctly (packets arrive and the server responds — confirmed via tcpdump).
  - From OUTSIDE the country (independent probes from 7 countries: Brazil, Spain, Finland, Iran, USA, etc.): port 5060 is STILL fully blocked (connection timeout — packets never reach our server).
  - For comparison: port 8080 on the same IP works normally from all of the above countries.

Technical conclusion:
The opening applied so far covers local/national traffic only. Inbound INTERNATIONAL traffic to port 5060 is still being filtered at the International Gateway level.

Specific request:
  Please open inbound TCP + UDP port 5060 on the International Gateway for traffic arriving from international routes, destined to IP 78.155.66.250 only.

Reminder: this port is used exclusively by the official Ookla Speedtest server protocol (Server ID: 75960) and is NOT related to VoIP/SIP services. Final Ookla certification depends on international reachability of this port.

Technical contact: ai@twin-tc.net

Best regards,
TWIN TC LLC — https://twin-tc.net`;

const LETTERS = {
  followup: {
    title: "خطاب المتابعة — البوابة الدولية",
    badge: "الأحدث — أرسل هذا",
    ar: LETTER2_AR,
    en: LETTER2_EN,
    printTitle: "TWIN TC LLC — متابعة: فتح المنفذ 5060 على البوابة الدولية",
  },
  initial: {
    title: "الخطاب الأول — طلب الفتح",
    badge: null,
    ar: LETTER_AR,
    en: LETTER_EN,
    printTitle: "TWIN TC LLC — طلب رسمي لفتح المنفذ 5060",
  },
};

export default function IspLetterCard() {
  const [open, setOpen] = useState(false);
  const [copied, setCopied] = useState(false);
  const [active, setActive] = useState("followup");

  const letter = LETTERS[active];

  const copyLetter = async () => {
    try {
      await navigator.clipboard.writeText(letter.ar + "\n\n----------------------------\n\n" + letter.en);
      setCopied(true);
      setTimeout(() => setCopied(false), 2500);
    } catch (e) {
      console.error("copy failed", e);
    }
  };

  const printLetter = () => {
    const w = window.open("", "_blank");
    if (!w) return;
    w.document.write(`<!doctype html><html lang="ar" dir="rtl"><head><meta charset="utf-8">
      <title>${letter.printTitle}</title>
      <style>
        body{font-family:'Segoe UI',Tahoma,sans-serif;line-height:1.9;padding:40px;max-width:800px;margin:auto;color:#111}
        pre{white-space:pre-wrap;font-family:inherit;font-size:15px}
        .en{direction:ltr;text-align:left;border-top:2px solid #999;margin-top:30px;padding-top:20px}
        h1{font-size:18px;border-bottom:3px solid #0e7490;padding-bottom:10px}
      </style></head><body>
      <h1>${letter.printTitle}</h1>
      <pre>${letter.ar}</pre>
      <div class="en"><pre>${letter.en}</pre></div>
      <script>window.onload = () => window.print();</scr` + `ipt></body></html>`);
    w.document.close();
  };

  return (
    <section className="card isp-letter-card" data-testid="isp-letter-card">
      <div className="card-head">
        <h2>📨 خطابات مزوّد الإنترنت — فتح المنفذ 5060</h2>
        <button
          className="btn btn-ghost btn-sm"
          onClick={() => setOpen(!open)}
          data-testid="isp-letter-toggle-btn"
        >
          {open ? "إخفاء الخطاب ▲" : "عرض الخطاب ▼"}
        </button>
      </div>
      <p className="tickets-sub">
        خطابات رسمية جاهزة (عربي + إنجليزي) موثّقة بنتائج الفحوصات — بعد إفادة المزوّد بالفتح، استخدم خطاب المتابعة لطلب الفتح على البوابة الدولية تحديداً
      </p>

      <div className="letter-tabs" data-testid="isp-letter-tabs">
        {Object.entries(LETTERS).map(([key, l]) => (
          <button
            key={key}
            className={`letter-tab ${active === key ? "active" : ""}`}
            onClick={() => setActive(key)}
            data-testid={`isp-letter-tab-${key}`}
          >
            {l.title}
            {l.badge && <span className="letter-tab-badge">{l.badge}</span>}
          </button>
        ))}
      </div>

      <div className="isp-letter-actions">
        <button className="btn btn-primary btn-sm" onClick={copyLetter} data-testid="isp-letter-copy-btn">
          {copied ? "✓ تم النسخ!" : "📋 نسخ الخطاب"}
        </button>
        <button className="btn btn-ghost btn-sm" onClick={printLetter} data-testid="isp-letter-print-btn">
          🖨️ طباعة / PDF
        </button>
      </div>

      {open && (
        <div className="isp-letter-body" data-testid="isp-letter-body">
          <pre className="isp-letter-text">{letter.ar}</pre>
          <div className="isp-letter-divider">— English Version —</div>
          <pre className="isp-letter-text en" dir="ltr">{letter.en}</pre>
        </div>
      )}
    </section>
  );
}
